import script from "./FilePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilePreview.vue?vue&type=script&setup=true&lang=ts"

import "./FilePreview.vue?vue&type=style&index=0&id=d54cc588&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d54cc588"]])

export default __exports__